export const ROOT_URL = '/';
export const PROFILE_URL = '/profile';
export const PRODUCT_URL = '/product';
export const PRODUCT_DETAIL_URL = '/product/:slug';
export const CATEGORY_URL = '/category';
export const CATEGORY_DETAIL_URL = '/category/:slug';
export const REVIEW_URL = '/review';
export const REVIEW_DETAIL_URL = '/review/:id';
export const CHECKOUT_URL = '/checkout';
export const ORDER_CONFIRMATION_URL = '/order-confirmation';
export const ORDER_TRACK_URL = '/order-track';
export const DASHBOARD_URL = '/dashboard';
export const ORDER_HISTORY_URL = '/order-history';
export const ORDER_HISTORY_DETAIL_URL = '/order-history/:orderId';

// Helper functions to build URLs with slugs
export const buildProductDetailUrl = (slug) => `/product/${slug}`;
export const buildCategoryDetailUrl = (slug) => `/category/${slug}`;
